<template>
    <div class="container vertical-align login">
      <div class="row">
        <div class="col-md-5">
          <form class="form-signin" @submit.prevent="logar">
            <TopoComponent :empresa="nomeempresa"></TopoComponent>
            <p class="mb-4 font-weight-normal">Olá!</p>
            <p class="mb-4 font-weight-normal">Para ativar sua conta, precisamos de algumas informações, tudo bem?</p>
            <p class="mb-8 font-weight-normal">Caso tenha dependentes, todas as contas devem ser ativadas agora.</p>
            <p class="mb-4 font-weight-bold">Para continuar, informe o seu CPF</p>
            <div class="relative">
              <input type="text" id="inputCpf" class="form-control" v-mask="'###.###.###-##'" placeholder="Seu CPF " required="true" v-model="login">
              <svg id="email" data-name="icon-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>icone-email</title>
                <path class="st0" d="M16.63,15.72c-1.48,0-2.2,0.83-4.63,0.83c-2.44,0-3.14-0.83-4.63-0.83c-3.84,0-6.95,3.11-6.95,6.95V24H2.9
                  v-1.32c0-2.46,2.01-4.47,4.47-4.47c0.76,0,1.98,0.83,4.63,0.83c2.67,0,3.87-0.83,4.63-0.83c2.46,0,4.47,2.01,4.47,4.47V24h2.48
                  v-1.32C23.59,18.84,20.47,15.72,16.63,15.72z"/>
                <path class="st0" d="M12,0C7.89,0,4.55,3.34,4.55,7.45S7.89,14.9,12,14.9s7.45-3.34,7.45-7.45S16.11,0,12,0z M12,12.41
                  c-2.74,0-4.97-2.23-4.97-4.97c0-2.74,2.23-4.97,4.97-4.97c2.74,0,4.97,2.23,4.97,4.97C16.97,10.18,14.74,12.41,12,12.41z"/>
              </svg>
            </div>
            <p></p>
            <g-recaptcha
              data-sitekey="6LcQB_EUAAAAAPGeh3IGuaY5gWca1ig2BzQOsODm"
              :data-validate="validate"
              :data-callback="logar"
              data-btn-class="btn btn-lg btn-primary btn-block button success"
              >
              Prosseguir
            </g-recaptcha>
          </form>
        </div>
        <div class="col-md-7">
          <img :src="image('medico.svg')" alt="" class="img-fluid float-right medico">
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
</template>

<script>
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
import OctadeskComponent from '@/components/OctadeskComponent'
import TopoComponent from '@/components/TopoComponent'
import { getImage } from "../components/utils/fnUtils";
import firebase from 'firebase';

export default {
  components: { OctadeskComponent, TopoComponent, gRecaptcha },
  props: ['empresa','referer', 'redirectTo'],
  name: 'passo1',
  created(){
    //limpar
    sessionStorage.removeItem("idclinica")
    sessionStorage.removeItem("empresa")
    sessionStorage.removeItem("cpf")
    sessionStorage.removeItem("dependentes")
    sessionStorage.removeItem("origem")
    sessionStorage.removeItem("validation_address")
    sessionStorage.removeItem("validation_method")
    //empresa
    this.nomeempresa = this.empresa

    //valida https (caso o cliente não esteja em HTTP faz o redirect para HTTPS.)
    if(location.href.indexOf("localhost") < 0 && location.href.indexOf("https") < 0){
        location.href = location.href.replace("http","https");
    }
  },
  beforeMount() {
    if(this.empresa && this.empresa.toLowerCase() === 'docpass'){
      document.getElementById("estilo_conexa").setAttribute('disabled', 'disabled');
      document.getElementById("estilo_docpass").removeAttribute('disabled');
      sessionStorage.setItem('layout', 'docpass');
    }
  },
  mounted() {
    window.location.href =
      process.env.VUE_APP_NOVA_ATIVACAO_PACIENTE_VERIFICAR_CPF +
      window.location.pathname;
  },
  data() {
    return {
        login : null,
        nomeempresa: null
    }
  },
  methods : {
    image(name){
      return getImage(name)
    },
    logar(token){ 
      if(this.login == null){
        this.$notify({
            group: 'mensagens',
            type: 'error', 
            text: 'CPF é obrigatório!'
        })
      }
      else{
        this.enviarEventoVerificaCPF();
        sessionStorage.setItem("cpf", this.login)
        sessionStorage.setItem("captcha", token)
        if(this.referer && this.referer !== 'no-ref') sessionStorage.setItem("origem", this.referer.toUpperCase())
        if(this.redirectTo) sessionStorage.setItem("redirectTo", this.redirectTo)
        this.$router.push('/selecionar-clinica')
      }
    },
    validate() {
      return true;
    },
    enviarEventoVerificaCPF(){
      firebase.analytics().logEvent('TMN_Verificar_CPF', {'Ação': 'Clique no prosseguir (verifique sua conta)', 'Rotulo':'Clique no prosseguir', 'Categoria': 'N/A', 'Tela':'home'});
    }
  }
}
</script>